module.exports = __webpack_public_path__ + "img/reportsAndStatistics.3ef5ed45.svg";